import { ServerlessSplitMigration } from '@packages/types/dashboard/ServerlessMTMPoolManager';

import fetchWrapper from '../fetchWrapper';

export default {
  postServerlessSplitMigration(groupId: string, donorMTMName: string) {
    return fetchWrapper(`/nds/serverless/splitMigrations/${groupId}/${donorMTMName}`, {
      method: 'POST',
    });
  },
  getServerlessSplitMigration(splitMigrationId: string): Promise<ServerlessSplitMigration> {
    return fetchWrapper(`/nds/serverless/splitMigrations/${splitMigrationId}`, {
      method: 'GET',
    }).then((resp) => resp.json());
  },

  getServerlessSplitMigrationsByPool(poolId: string): Promise<Array<ServerlessSplitMigration>> {
    return fetchWrapper(`/nds/serverless/splitMigrations/pool/${poolId}`, {
      method: 'GET',
    }).then((resp) => resp.json());
  },
};
